import { ImageLoaderCSSStyleImpl } from '../../../../../../toolkit/imageloader/imageloadercss';


export class MultiSelectImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '71px', 
            height: '71px',
            borderRadius: "5px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/categorylist/viewmodel/categorycard/multiselectimageloadercss.ts